export default {
  en: {
    remark: 'Remark',
    resetToCurrentVersion: 'Reset to current version',
    resetToDefaultSetting: 'Reset to default setting'
  },
  th: {
    remark: 'หมายเหตุ',
    resetToCurrentVersion: 'ย้อนกลับไปใช้ค่าปัจจุบัน',
    resetToDefaultSetting: 'ย้อนกลับไปใช้ค่าเริ่มต้น'
  }
}
